/* eslint-disable */

<template>
  <div id="custom264345530216218624">
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base" v-if="currentPage === 0">
            <h3 class="font-bold mb-4 p-2 rounded" style="background-color: #0084ff">Drag and Drop</h3>
            <div class="flex items-between align-middle my-2 dataForensicsBlock ">
              <h4 class="self-center pr-4">High (CVSS: 8.2)<br>NVT: The IPSEC configuration uses a weak key
                agreement protocol<br>The IPSEC configuration uses a weak key agreement</h4>
              <div>
                <vue-draggable-container id="wb1" class="wbForensics">
                  <h5 class="dragBlock dataForensicsDragBlock cursor-pointer-simulation">1</h5>
                </vue-draggable-container>
                <vue-draggable-container id="wb1-2" class="wbForensics">
                  <h5 class="dragBlock dataForensicsDragBlock cursor-pointer-simulation">1</h5>
                </vue-draggable-container>
              </div>
            </div>
            <div class="flex items-between align-middle my-2 dataForensicsBlock ">
              <h4 class="self-center pr-4">High (CVSS: 8.2)NVT:<br>Open AXFR permitted<br>The server permits
                AXFR from anonymous sources.</h4>
              <vue-draggable-container id="wb2" class="wbForensics">
                <h5 class="dragBlock dataForensicsDragBlock cursor-pointer-simulation">2</h5>
              </vue-draggable-container>
            </div>
            <div class="flex items-between align-middle my-2 dataForensicsBlock ">
              <h4 class="self-center pr-4">High (CVSS: 8.0)NVT:<br>SSL/TLS: Electronic Codebook Mode of
                Operation in use<br>Reports where attack vectors exist only on HTTPS services.</h4>
              <vue-draggable-container id="wb3" class="wbForensics">
                <h5 class="dragBlock dataForensicsDragBlock cursor-pointer-simulation">3</h5>
              </vue-draggable-container>
            </div>
          </vx-card>

          <vx-card class="" title="Page Switcher">
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-arrow-right-circle"
                       style="width: 100%; z-index: 1"
                       class="my-4 font-bold flex" button size="large" @click="next_page" v-if="currentPage === 0">Next
              Page
            </vs-button>
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-arrow-left-circle" style="width: 100%"
                       class="my-4 font-bold" button size="large" @click="previous_page" v-else>Previous Page
            </vs-button>
          </vx-card>

        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div :style="{'display': currentPage === 0 ? '' : 'none!important'}">

              <div class="vx-row">
                <div class="vx-col w-4/5 p-5 rounded">
                  <div class="mb-3 border-white border-4 border-solid p-3">
                    <h2 class="font-bold p-2 rounded" style="background-color: #0084ff">Site A</h2>
                    <div class="grid grid-cols-5 gap-4">
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">DNS</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputDNS"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">HVAC</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputHVAC"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">PLC</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputPLC2"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Pumps</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputPumps"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Application Server 01</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputAs01"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">SCADA Master Controller</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputSCADA"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Directory Server</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputDs"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Web Server 01</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputWs01"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Application Server 02</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputAs02"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">VPN Concentrator</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="aInputVpnC"/>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="vx-col w-1/5">
                  <div class="flex justify-center items-center align-middle h-full p-5">
                    <div class="border-white border-2 border-solid rounded p-4 bg-white z-10">
                      <img src="https://cdn.discordapp.com/attachments/746242308084858900/874790819217940591/internet.png" width="125" alt="" >
                      <h2 class="text-center mt-3 text-black font-bold">Internet</h2>
                    </div>
                      <div class="forensics-line-left"></div>
                      <div class="forensics-line-up"></div>
                  </div>
                </div>
              </div>

              <div class="vx-row">

                <div class="vx-col w-1/5">
                  <div class="forensics-line-rotate"></div>
                </div>

                <div class="vx-col w-4/5 p-5 rounded">
                  <div class="mt-3 border-white border-4 border-solid p-3">
                    <h2 class="font-bold p-2 rounded" style="background-color: #0084ff">Site B</h2>
                    <div class="grid grid-cols-4 gap-4">
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">VPN Concentrator</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="bInputVpnC"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Application Server 03</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="bInputAs03"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Application Server 04</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="bInputAs04"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">File Server</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="bInputFs"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">PLC</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="bInputPLC"/>
                      </div>
                      <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                        <h4 class="font-semibold mb-2 ">Pumps</h4>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics" id="bInputPumps"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <div class="grid-cols-2 gap-4" :style="{'display': currentPage === 1 ? 'grid' : 'none!important'}">
              <vx-card class="mb-base">
                <div class="border-white border-solid border-2 rounded">
                  <div class="flex bg-primary-gradient p-5 ">
                    <h3 class="font-bold self-center">High (CVSS: 8.2) NVT: The IPSEC</h3>
                  </div>
                  <div class="p-5">
                    <h5>NVT: The IPSEC configuration uses a weak key agreement protocol</h5>
                    <h2 class="mt-3">Summary</h2>
                    <h5 class="mt-2">The IPSEC configuration uses a weak key agreement protocol.</h5>
                    <h2 class="mt-3">Role</h2>
                    <v-select v-model="page2.IPSEC.value"
                              :options="page2Options" class="w-full mt-2"
                              placeholder="Select from Dropdown"/>
                    <small v-if="page2.IPSEC.marked_score === false"
                           class="ml-1 text-danger font-semibold">This answer is incorrect</small>
                    <small v-if="page2.IPSEC.marked_score === true"
                           class="ml-1 text-success font-semibold">This answer is correct</small>
                  </div>
                </div>
              </vx-card>

              <vx-card class="mb-base">
                <div class="border-white border-solid border-2 rounded">
                  <div class="flex bg-primary-gradient p-5 ">
                    <h3 class="font-bold self-center">High (CVSS: 8.2) NVT: The IPSEC</h3>
                  </div>
                  <div class="p-5">
                    <h5>NVT: The IPSEC configuration uses a weak key agreement protocol</h5>
                    <h2 class="mt-3">Summary</h2>
                    <h5 class="mt-2">The IPSEC configuration uses a weak key agreement protocol.</h5>
                    <h2 class="mt-3">Role</h2>
                    <v-select v-model="page2.IPSEC2.value"
                              :options="page2Options" class="w-full mt-2"
                              placeholder="Select from Dropdown"/>
                    <small v-if="page2.IPSEC2.marked_score === false"
                           class="ml-1 text-danger font-semibold">This answer is incorrect</small>
                    <small v-if="page2.IPSEC2.marked_score === true"
                           class="ml-1 text-success font-semibold">This answer is correct</small>

                  </div>
                </div>
              </vx-card>

              <vx-card class="mb-base">
                <div class="border-white border-solid border-2 rounded">
                  <div class="flex bg-primary-gradient p-5 ">
                    <h3 class="font-bold self-center">High (CVSS: 8.2) NVT: Open AXFR permitted</h3>
                  </div>
                  <div class="p-5">
                    <h5>NVT: Open AXFR permitted</h5>
                    <h2 class="mt-3">Summary</h2>
                    <h5 class="mt-2">The server permits AXFR from anonymous sources.</h5>
                    <h2 class="mt-3">Role</h2>
                    <v-select v-model="page2.CVSS82.value"
                              :options="page2Options" class="w-full mt-2"
                              placeholder="Select from Dropdown"/>
                    <small v-if="page2.CVSS82.marked_score === false"
                           class="ml-1 text-danger font-semibold">This answer is incorrect</small>
                    <small v-if="page2.CVSS82.marked_score === true"
                           class="ml-1 text-success font-semibold">This answer is correct</small>

                  </div>
                </div>
              </vx-card>

              <vx-card class="mb-base">
                <div class="border-white border-solid border-2 rounded">
                  <div class="flex bg-primary-gradient p-5 ">
                    <h3 class="font-bold self-center">High (CVSS: 8.0) NVT: SSL/TLS: Electronic</h3>
                  </div>
                  <div class="p-5">
                    <h5>NVT: SSL/TLS: Electronic Codebook Mode of Operation in use</h5>
                    <h2 class="mt-3">Summary</h2>
                    <h5 class="mt-2">Reports where attack vectors exist only on HTTPS services.</h5>
                    <h2 class="mt-3">Role</h2>
                    <v-select v-model="page2.CVSS80.value"
                              :options="page2Options" class="w-full mt-2"
                              placeholder="Select from Dropdown"/>
                    <small v-if="page2.CVSS80.marked_score === false"
                           class="ml-1 text-danger font-semibold">This answer is incorrect</small>
                    <small v-if="page2.CVSS80.marked_score === true"
                           class="ml-1 text-success font-semibold">This answer is correct</small>

                  </div>
                </div>
              </vx-card>
            </div>

          </vx-card>
        </div>
      </div>
    </vue-sortable>

  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,


      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      },

      currentPage: 0,

      page2Options: [
        'Upgrade cipher suites',
        'Implement an ACL in BIND configuration',
        'Implement a honeypot',
        'Download and install the latest firmware',
        'Configure and SSH daemon',
        'Segment ICS and SCADA equipment',
        'Reissue a PKI certificate from a trusted CA'
      ],

      page2: {
        IPSEC: {
          answer: 'Upgrade cipher suites',
          value: '',
          marked_score: null
        },
        IPSEC2: {
          answer: 'Upgrade cipher suites',
          value: '',
          marked_score: null
        },
        CVSS82: {
          answer: 'Implement an ACL in BIND configuration',
          value: '',
          marked_score: null
        },
        CVSS80:{
          answer: 'Reissue a PKI certificate from a trusted CA',
          value: '',
          marked_score: null
        }
      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const origSourceContainer = x.data.dragEvent.data.originalSource
      if (overContainer.classList.contains('wbForensics')) {
        if (overContainer.children.length > 0) {
          return x.cancel()
        }
      }
      if (overContainer && overContainer.classList.contains('dropzone')) {
        const id = origSourceContainer.id
        document.getElementById(`${id  }-cloned`).style.display = 'inline-flex'
        document.getElementById(id).classList.remove('dragBlock')
        document.getElementById(id).classList.add('stillBlockForensicsClassification')
        return
      }
      document.getElementById(`${origSourceContainer.id  }-cloned`).outerHTML = ''
    },
    markSimulation () {

      let total_score = 0


      if (document.getElementById('aInputDNS').textContent  === '2') {
        document.getElementById('aInputDNS').style.borderColor = '#28C76F'
        document.getElementById('aInputDNS').style.backgroundColor = '#28C76F'
        total_score++
      }

      if (document.getElementById('aInputVpnC').textContent  === '1') {
        document.getElementById('aInputVpnC').style.borderColor = '#28C76F'
        document.getElementById('aInputVpnC').style.backgroundColor = '#28C76F'
        total_score++
      }


      if (document.getElementById('aInputWs01').textContent  === '3') {
        document.getElementById('aInputWs01').style.borderColor = '#28C76F'
        document.getElementById('aInputWs01').style.backgroundColor = '#28C76F'
        total_score++
      }


      if (document.getElementById('bInputVpnC').textContent  === '1') {
        document.getElementById('bInputVpnC').style.borderColor = '#28C76F'
        document.getElementById('bInputVpnC').style.backgroundColor = '#28C76F'
        total_score++
      }

      for (const [key, value] of Object.entries(this.page2)) {
        if (value.value === value.answer) {
          this.page2[key].marked_score = true
          total_score++
        } else {
          this.page2[key].marked_score = false
        }
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    },
    previous_page () {
      this.currentPage = 0
    },
    next_page () {
      this.currentPage = 1
    }
    /* click_remove (x) {
      const target = x.target
      if (target.classList.contains('stillBlockForensicsClassification')) {
        target.outerHTML = ''
      }
    } */
  },
  components: {
    draggable,
    Prism,
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>
<style lang="scss">


.stillBlockForensicsClassification {
  padding: 12px;
  word-break: break-all;
  background-color: rgba(var(--vs-primary), 1);
  display: inline-flex;
  margin: 5px;
  border-radius: 5px;
  font-size: 1.4rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 999999999999 !important;
  border: 0.180rem solid transparent;
  font-weight: 800 !important;
  cursor: url('~@/assets/images/cursor/trash-cursor.png'), auto !important;
  background-color: #ffd900;
  color: #000000 !important;
}

#custom264345530216218624 {
  .forensics-line-up {
      position: absolute;
      left: auto;
      right: auto;
      width: 6px;
      height: 330px;
      margin: 15vh 0 0 0;
      background-color: #ffffff;
      line-height: 50vh;
  }
  .forensics-line-left {
    position: absolute;
    width: 6vw;
    height: 6px;
    margin-right: 6vw;
    background-color: #ffffff;
  }
  .forensics-line-rotate {
    position: absolute;
    z-index: 0;
    width: 11.5vw;
    height: 6px;
    margin-top: 3vh;
    background-color: #ffffff;
    -webkit-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg);
  }
  .wbForensics {
    min-width: 65px;
    min-height: 55px;
    max-height: 65px;
    border: 1px solid rgba(255, 255, 255, 0.75);
    justify-content: center;
    display: flex;
  }
  .dataForensicsDragBlock {
    min-width: 50px !important;
    background-color: #ffd900;
    color: #000000 !important;
    font-weight: 800 !important;
  }

  .dataForensicsBlock  {
    border-color: #ffffff;
    border-style: solid;
    border-width: 2px 0 0 0;
    padding: 7px 0 7px 0;
  }

  .answerForensics {
    min-height: 57.5px;

  }
}

</style>
